import DocumentsHeader from './DocumentsHeader';
import DocumentsLandingPres from './DocumentsLandingPres';
import DocumentsTablePres from './DocumentsTablePres';
import DocumentsDetailPres from './DocumentsDetailPres';
import DocumentInfoPres from './DocumentInfoPres';

export { DocumentsHeader, DocumentsLandingPres, DocumentsTablePres, DocumentsDetailPres, DocumentInfoPres };



// WEBPACK FOOTER //
// ./src/ui/features/Documents/presentational/index.js